export const PictureIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_8666_14010)'>
      <path
        d='M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5L11 16.51L14.5 12L19 18H5L8.5 13.5Z'
        fill='inherit'
      />
    </g>
    <defs>
      <clipPath id='clip0_8666_14010'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const VideoIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_8708_20166)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5ZM10.622 8.41492C10.5618 8.37476 10.4919 8.35168 10.4196 8.34814C10.3473 8.34459 10.2755 8.36071 10.2116 8.39478C10.1478 8.42885 10.0944 8.47959 10.0572 8.5416C10.0199 8.60361 10.0001 8.67457 10 8.74692V15.2529C10.0001 15.3253 10.0199 15.3962 10.0572 15.4582C10.0944 15.5202 10.1478 15.571 10.2116 15.6051C10.2755 15.6391 10.3473 15.6552 10.4196 15.6517C10.4919 15.6481 10.5618 15.6251 10.622 15.5849L15.501 12.3329C15.5559 12.2964 15.6009 12.2469 15.632 12.1888C15.6631 12.1307 15.6794 12.0658 15.6794 11.9999C15.6794 11.934 15.6631 11.8691 15.632 11.811C15.6009 11.7529 15.5559 11.7034 15.501 11.6669L10.622 8.41492Z'
        fill='inherit'
      />
    </g>
    <defs>
      <clipPath id='clip0_8708_20166'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
